import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleIService,
  IIntegrationRuleIService,
} from "../models/integration-rule-i-service";

const INTEGRATION_RULE_I_SERVICE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleIService/";

export const createIntegrationRuleIService = (
  item: INewIntegrationRuleIService,
) => {
  return GlobalAxios.post(INTEGRATION_RULE_I_SERVICE_ROUTE, item);
};

export const getIntegrationRuleIServiceById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleIService>(
    INTEGRATION_RULE_I_SERVICE_ROUTE + id,
  );
};

export const updateIntegrationRuleIServiceById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleIService;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_I_SERVICE_ROUTE + id, item);
};
